import styled from 'styled-components'

export const StyledLimitSwap = styled.div`
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.bgCard};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 45vw;
  max-width: 435px;
  padding: 20px 15px;
  position: relative;
  border: 0.5px solid ${({ theme }) => theme.colors.borderBrand};

  ${({ theme }) => theme.media.lg`
    width: 100% !important;
  `}
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`

export const ArrowButton = styled.button`
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 1.5px solid #dbdce5;
  border-radius: 28px;
  cursor: pointer;
  outline: none;
  padding: 0;
  transition: transform 0.2s ease-in-out;
  width: 28px;
  height: 28px;

  img {
    width: 28px;
    height: 28px;
  }

  &:hover {
    transform: rotate(180deg);
  }
`

export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  width: 100%;
  margin: 20px 0 12px;
`
